export const API_ROUTES = {
  AUTH: {
    LOGIN: "v1/users/authenticate",
    WORDPRESS_LOGIN: "https://shop.petsync.in/wp-json/jwt-auth/v1/token",
  },

};
